import { get, post } from "./common/http";
import { BASE_URL } from "./common/const";
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";

// export const GetDetail = (data: any) =>
//   POST_ENC(`${BASE_URL}/api/Category/GetDetail`, data);

export const GetLabelTypeList = () =>
   GET_ENC(`${BASE_URL}/api/Label/GetListForCategoryType`, null);

export const GetLabelDetail = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Label/GetDetail?` + params, null);

export const GetLabelList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Label/GetList?` + params, null);

export const GetLabelMappingWithAccountingSummary = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Label/GetLabelMappingWithAccountingSummary?` + params, null);

export const GetLabelDetailed = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Label/GetLabelDetailed?` + params, null);
export const GetProjectPartyBalanceDetailed = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Label/GetProjectPartyBalanceDetailed?` + params, null);

export const GetLabelLevelPartyBalanceReport = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Label/LabelLevelPartyBalance?` + params, null);

export const CreateLabel = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Label/Create`, data);

export const UpdateLabel = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Label/Update`, data);

export const MappingLabel = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Label/LabelMapping`, data);

export const DeleteLabel = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Label/Delete`, data);

export const GetLabelDetailedReport = (params: any) =>
     GET_ENC(`${BASE_URL}/api/Report/LabelDetailed?` + params, null);

export const GetLabelSummaryReport = (params: any) =>
     GET_ENC(`${BASE_URL}/api/Report/LabelSummary?` + params, null);

export const UpdateDefaultLabel = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Label/UpdateDefault`, data);

export const GetPartyTabelList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Label/GetPartyTabelList?` + params, null);

export const GetBalanceList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Label/GetBalanceTypeList?` + params, null);

